import { ProductFilterDTO } from '../api'

export class ProductFilterRequest implements ProductFilterDTO {
  status: number[];
}
